import React, { useRef } from "react"
import { Collapse } from "antd"
import { ChevronDown } from "../Icon"
import "./LinkUnduhan.less"

const { Panel } = Collapse

export default function LinkUnduhan(props) {
  const ref = useRef(null)
  const goToLinkUnduhan = () => {
    window.scrollTo({
      top: ref.current.getBoundingClientRect().top - 70,
      behavior: "smooth",
    })
  }
  return (
    <>
      <div onClick={goToLinkUnduhan} className="download-button">
        <svg
          width={41}
          height={42}
          viewBox="0 0 41 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 0.5H0.5V1V41V41.5H1H41H41.5V41V1V0.5H41H1Z"
            fill="#FAFAFA"
            stroke="#DDDDDD"
          />
          <path
            d="M30 23C29.7348 23 29.4804 23.1054 29.2929 23.2929C29.1054 23.4804 29 23.7348 29 24V28C29 28.2652 28.8946 28.5196 28.7071 28.7071C28.5196 28.8946 28.2652 29 28 29H14C13.7348 29 13.4804 28.8946 13.2929 28.7071C13.1054 28.5196 13 28.2652 13 28V24C13 23.7348 12.8946 23.4804 12.7071 23.2929C12.5196 23.1054 12.2652 23 12 23C11.7348 23 11.4804 23.1054 11.2929 23.2929C11.1054 23.4804 11 23.7348 11 24V28C11 28.7956 11.3161 29.5587 11.8787 30.1213C12.4413 30.6839 13.2044 31 14 31H28C28.7956 31 29.5587 30.6839 30.1213 30.1213C30.6839 29.5587 31 28.7956 31 28V24C31 23.7348 30.8946 23.4804 30.7071 23.2929C30.5196 23.1054 30.2652 23 30 23ZM20.29 24.71C20.3851 24.801 20.4972 24.8724 20.62 24.92C20.7397 24.9729 20.8691 25.0002 21 25.0002C21.1309 25.0002 21.2603 24.9729 21.38 24.92C21.5028 24.8724 21.6149 24.801 21.71 24.71L25.71 20.71C25.8983 20.5217 26.0041 20.2663 26.0041 20C26.0041 19.7337 25.8983 19.4783 25.71 19.29C25.5217 19.1017 25.2663 18.9959 25 18.9959C24.7337 18.9959 24.4783 19.1017 24.29 19.29L22 21.59V12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11C20.7348 11 20.4804 11.1054 20.2929 11.2929C20.1054 11.4804 20 11.7348 20 12V21.59L17.71 19.29C17.6168 19.1968 17.5061 19.1228 17.3842 19.0723C17.2624 19.0219 17.1319 18.9959 17 18.9959C16.8681 18.9959 16.7376 19.0219 16.6158 19.0723C16.4939 19.1228 16.3832 19.1968 16.29 19.29C16.1968 19.3832 16.1228 19.4939 16.0723 19.6158C16.0219 19.7376 15.9959 19.8681 15.9959 20C15.9959 20.1319 16.0219 20.2624 16.0723 20.3842C16.1228 20.5061 16.1968 20.6168 16.29 20.71L20.29 24.71Z"
            fill="#FF6900"
          />
        </svg>
      </div>

      <div className="link-unduhan" ref={ref} id="link-unduhan-anc">
        <h3>Link Unduhan</h3>
        <Collapse
          defaultActiveKey={["0"]}
          expandIconPosition="right"
          expandIcon={({ isActive }) => <ChevronDown />}
        >
          {(props.Links || []).map(function (item, i) {
            return (
              <Panel header={item.header_title} key={i + 1}>
                {(item.items || []).map(function (file, ii) {
                  return (
                    <div key={"an" + ii} style={{ marginBottom: 4 }}>
                      <a
                        href={file.file}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {file.item_title}
                      </a>
                    </div>
                  )
                })}
              </Panel>
            )
          })}
        </Collapse>
      </div>
    </>
  )
}
